import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import './mood.analytic.chartjs.mjs';

declareVconsoleComponent('moodAnalytic', () => import('./MoodAnalytic.vue'), 'mood_analytic:component')
